import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { DialogActions } from "@mui/material";

export interface SimpleListDialogProps {
  title: string;
  listItems: string[] | undefined;
  emptyListMessage: string;
  open: boolean;
  onClose: () => void;
  showDeleteButton?: boolean;
  onDelete?: (item: string) => void;
  onSelect?: (item: string) => void;
  actions?: React.ReactNode;
}

export default function SimpleListDialog(props: SimpleListDialogProps) {
  const { onClose, open, listItems, showDeleteButton, onDelete, onSelect, actions } = props;

  return (
    <Dialog onClose={onClose} open={open} maxWidth="xs">
      <DialogTitle>{props.title}</DialogTitle>
      <List sx={{ pt: 0 }}>
        {listItems && listItems.length ? (
          listItems.map((it) => (
            <ListItem
              key={it}
              secondaryAction={
                showDeleteButton && onDelete ? (
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(it);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                ) : null
              }
            >
              <ListItemButton onClick={() => onSelect?.(it)}>
                <ListItemText primary={it} />
              </ListItemButton>
            </ListItem>
          ))
        ) : (
          <ListItem disableGutters>
            <ListItemButton>
              <ListItemText primary={props.emptyListMessage} />
            </ListItemButton>
          </ListItem>
        )}
      </List>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
}
